<template>
<div>
     <button 
            class="pinyinbtn"
            @click="showDialog"
            :style="[btnStyle]">
            <i class="pinyin-icon" :class="[{disabled:disabled}]"></i>
            <b>汉字转拼音</b>
        </button>
    <div v-show="show"
         class="choicepinyin">
            <div class="svgdialog">
                <div class="title">
                    <p>汉字转拼音</p>
                    <span class="close"
                        @click.stop="closePinyin"></span>
                </div>
                <fieldset>
                    <!-- <legend>待转化内容</legend> -->
                    <textarea maxlength="1000"
                            v-model="beforestr"
                            placeholder="请输入待转换内容"
                            class="beforetextarea"></textarea>
                </fieldset>
                <div class="middlediv">
                    <template>
                        <el-radio-group v-model="model">
                            <el-radio :label="0">上拼音下汉字</el-radio>
                            <el-radio :label="1">左汉字右拼音</el-radio>
                            <el-radio :label="2">只有拼音</el-radio>
                        </el-radio-group>
                    </template>
                    <span @click="changePinyin"
                        class="change-btn">转换</span>
                </div>
                <fieldset class="after">
                    <!-- <legend>转化后内容</legend> -->
                    <div class="afterdiv">
                        <template v-for="(value,key) in afterarr">
                            <span v-if="value.type=='text'"
                                :key="key">{{value.value}}</span>
                            <span v-else-if="value.type=='br'"
                                :key="key"><br></span>
                            <span v-else
                                :key="key"
                                @mouseover="showTips($event)"
                                v-bind:class="['pinyin',{'more':value.pinyin.length>1,'m_1':model==1,'m_2':model==2}]">
                                <i v-if="model!=1">{{value.pinyin[value.num]}}</i>
                                <label>{{value.value}}</label>
                                <i v-if="model==1">{{value.pinyin[value.num]}}</i>
                                <span class="m-box"
                                    v-if="value.pinyin.length>1">
                                    <span v-for="(morevalue,morekey) in value.pinyin"
                                        @click="value.num=morekey"
                                        :key="morekey">{{morevalue}}</span>
                                </span>
                            </span>
                        </template>
                    </div>
                </fieldset>
                <div class="bottomdiv">
                    <span>鼠标悬停到<font color="#FF0000">红色文本</font>上可更换多音字拼音哦！</span>
                    <button @click="closePinyin"
                            class="cancel">取消</button>
                    <button @click="quotekPinyin">确认</button>
                </div>
            </div>
    </div>
</div>

</template>

<script>
const pinyinData = () => import(/* webpackChunkName: "pinyinData" */ './Pinyin.json');
export default {
    name: 'han2PinYin',
    props: {
        str: { // 待转换的字符串
            type: String,
            default: ''
        },
        changeType: {
            type: String,
            default:'html'
        },
        mode: { // 转换模式
            type: Number,
            default: 1
        },
        // 按钮样式
        btnStyle: {
            type: Object,
            default: function () { 
                return {}
             }
        },
        multi: {
            type: Array,
            default: function () { 
                return []
            }
        },
        disabled: {
            type: Boolean,
            default: false
        }
        
    },
    data () {
        return {
            show: false,
            callback: null,
            data: {}, // 拼音数据库
            beforestr:'',
            model:0,
            type: 'html',
            afterarr: [], // 已转换的字符数组
            getHtml: ''
        };
    },
    created: function () {
        pinyinData().then((data) => {
            this.data = data;
        });
        this.afterarr = [];
        this.model = this.mode - 1
        this.beforestr = this.str
        if (this.beforestr !== '') {
                this.changePinyin();
        }
    },
    watch: {
        // str: {
        //     handler: function (newVal) {
        //         this.beforestr = newVal
        //     },
        // },
        show:{
            handler: function (newVal) { 
                if(newVal){
                    this.afterarr = [];
                    this.model = this.mode - 1
                    this.beforestr = this.str
                    if (this.beforestr !== '') {
                        this.changePinyin();
                    }
                }
             }
        }
    },
    methods: {
        // 初始化坐标
        // choicePinyin: function (str, callback, type) {
        //     this.show = true;
        //     this.beforestr = str;
            
        //     this.callback = callback;
        //     // 有文字启动时自动转换
           

        //     if (type) {
        //         this.type = type;
        //     }
        // },
        showDialog: function () {
            if(!this.disabled){
                this.show = true
            }
         },
        // 转换拼音
        changePinyin: function () {
            // let str = this.beforestr.replace(new RegExp('\\s|\\r\\n', 'gim'), '');
            // 使用$字符表明有一个换行，输出时将该字符替换为换行符
            let str = this.beforestr.replace(/\n/g, '$');
            // console.log(str, str.length);
            if (str.length > 200) {
                alert('输入转换文本不能超过200个字');
                return;
            }
            // str为空的时候
            if (str === '') {
                return;
            }

            // str不为空的时候
            let len = str.length;
            this.afterarr = [];
            for (var i = 0; i < len; i++) {
                if (str[i] !== '$' && str[i].charCodeAt() > 0xa0 && typeof this.data[str[i]] !== 'undefined' && this.data[str[i]].length > 0 && /^[\u4e00-\u9fa5]+$/.test(str[i])) {
                    this.afterarr.push({ type: 'pinyin', value: str[i], num: this.multi[i] ? this.multi[i]:0, pinyin: this.data[str[i]].split(',') });
                } else if (str[i] === '$') {
                    this.afterarr.push({ type: 'br', value: str[i] });
                } else {
                    this.afterarr.push({ type: 'text', value: str[i] });
                }
            }
        },
        // 引用拼音
        quotekPinyin: function () {
            let htmlstr = ' ';
            for (let i = 0; i < this.afterarr.length; i++) {
                let value = this.afterarr[i];
                if (value.type === 'text') {
                    htmlstr += value.value;
                } else {
                    if (this.model === 2) {
                        if (value.type === 'br') {
                            htmlstr += '<br/>';
                        } else {
                            htmlstr += value.pinyin[value.num] + ' ';
                        }
                    } else {
                        if (this.model === 1 && value.type !== 'br') {
                            htmlstr += '<span contenteditable="false" class="pinyin m_1">';
                            htmlstr += '<label>' + value.value + '</label>';
                            htmlstr += '<v>' + value.pinyin[value.num] + '</v>';
                        } else if(value.type !== 'br') {
                            htmlstr += '<span class="pinyin" contenteditable="false">';
                            htmlstr += '<v>' + value.pinyin[value.num] + '</v>';
                            htmlstr += '<label>' + value.value + '</label>';
                        }
                        htmlstr += '</span> ';
                        if (value.type === 'br'){
                            htmlstr += '<br/>';
                        }
                    }
                }
            }
            this.show = false;
            let arr=this.afterarr.map(function(item){return item.num;})
            this.afterarr = [];
            this.$nextTick(() => {
                if (this.changeType === 'html') {
                    // this.callback(htmlstr);
                    this.$emit('change', htmlstr)
                     this.beforestr = ''
                } else {
                    // 返回转换前文本内容
                    // this.callback(htmlstr, this.beforestr);
                    this.$emit('change', htmlstr, this.beforestr, this.model + 1, arr)
                    this.beforestr = ''
                }
            });
        },
        showTips: function (e) {
            let position = this.$el.querySelector('.afterdiv').getBoundingClientRect();
            let w = position.left + position.width; // 获取容器的右侧位置

            if (e.target.parentNode.querySelector('.m-box')) {
                // 当前拼音宽加提示框宽
                let left = e.target.parentNode.getBoundingClientRect().width + e.target.parentNode.querySelector('.m-box').getBoundingClientRect().width;
                if (e.clientX + left >= w) { // 提示框位置超出容易 显示在当前拼音右侧
                    e.target.parentNode.querySelector('.m-box').style.left = -left + 'px';
                } else {
                    e.target.parentNode.querySelector('.m-box').style.left = 'auto';
                }
            }
        },
        // 关闭svg对话框
        closePinyin: function () {
            this.show = false;
            this.$nextTick(() => {
                // this.callback('');
                 this.$emit('change','')
                 this.beforestr = ''
            });
        },
        // 关闭svg对话框
        closedialog: function () {
        },
    },
};
</script>

<style lang="scss" scoped>
    .pinyinbtn{
        border:none;
        width:90px;
        height: 60px;
        background: transparent;
        padding: 0;
        text-align: center;
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding: 0 10px;
        box-sizing: border-box;
        font-size:14px;
        outline: none;
        cursor: pointer;
        .pinyin-icon{
            display: inline-block;
            flex: 0 0 28px;
            width: 28px;
            height: 28px;
            margin: 0 auto;
            background: url(./icon_tool_transformation.png) no-repeat center;
            background-size: 28px 28px;
            &.disabled{
                background: url(./icon_tool_transformation_prohibit.png) no-repeat center;
            }
        }
        b{
            font-weight: normal;
        }
    }
$maincolr: #6BADFC;
@mixin btn($borderColor, $bgColor, $textColor) {
    display: inline-block;
    width: 80px;
    height: 32px;
    line-height: 32px;
    border-radius: 4px;
    font-size: 14px;
    border: 1px solid $borderColor;
    background: $bgColor;
    color: $textColor;
    text-align: center;
    cursor: pointer;
}
.choicepinyin {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 5000;
    overflow: hidden;
    background: transparent;
    background: rgba(0, 0, 0, 0.4);
    & * {
        font-family: "customFont", "customFont1", "Microsoft YaHei",
            "sans serif";
        box-sizing: border-box;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
    div {
        &.svgdialog {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 600px;
            height: 500px;
            background: #ffffff;
            transform: translate(-50%, -50%);
            padding: 10px 27px;
            border-radius: 10px;
            .title {
                font-size: 14px;
                color: $maincolr;
                line-height: 35px;
                border-bottom: 1px solid $maincolr;
                display: flex;
                align-items: center;
                p {
                    flex: 0 0 calc(100% - 12px);
                    margin: 0;
                    text-align: left;
                }
                span.close {
                    flex: 0 0 12px;
                    height: 12px;
                    background: url("./images/icon_label_close.png") no-repeat
                        center center;
                    background-size: 100% 100%;
                    cursor: pointer;
                }
            }
            .beforetextarea {
                color: #333;
                width: 100%;
                padding: 0px;
                margin: 0px;
                border: 0px;
                resize: none;
                height: 98px;
                line-height: 20px;
                box-sizing: border-box;
                outline: none;
                &::-webkit-input-placeholder {
                    color: #c8c8c8;
                }
                &::-moz-placeholder {
                    /* Mozilla Firefox 19+ */
                    color: #c8c8c8;
                }
                &:-moz-placeholder {
                    /* Mozilla Firefox 4 to 18 */
                    color: #c8c8c8;
                }
                &:-ms-input-placeholder {
                    /* Internet Explorer 10-11 */
                    color: #c8c8c8;
                }
            }
            .middlediv {
                display: flex;
                justify-content: space-between;
                margin-top: 12px;
                line-height: 32px;
                .change-btn {
                    @include btn(#4d95fb, #fff, #4d95fb);
                }
            }
            .bottomdiv {
                height: 68px;
                line-height: 68px;
                font-size: 12px;
                color: #a0a0a0;
                span {
                    display: inline-block;
                    width: calc(100% - 160px - 15px);
                }
                button {
                    @include btn(#6BADFC, #6BADFC, #fff);
                    &.cancel {
                        @include btn(#6BADFC, #fff, #6BADFC);
                        margin-right: 15px;
                    }
                }
            }
            fieldset {
                padding: 5px 10px;
                margin: 0px;
                margin-top: 20px;
                border: 1px solid #dcdcdc;
                border-radius: 5px;
                &.after {
                    margin-top: 12px;
                }
            }
            legend {
                color: #999;
            }
            .afterdiv {
                color: #333;
                width: 100%;
                padding: 0px;
                margin: 0px;
                height: 176px;
                overflow: auto;
                box-sizing: border-box;
                text-align: left;
            }
            .pinyin {
                &.m_1 {
                    v,
                    i,
                    label {
                        display: inline-block;
                    }
                }
                &.m_2 {
                    label {
                        display: none;
                    }
                }
                &.more {
                    color: #f00;
                    cursor: pointer;
                    &:hover {
                        .m-box {
                            display: block;
                            &.left {
                                left: -65px;
                            }
                        }
                    }
                    label {
                        color: #f00;
                    }
                    .m-box {
                        display: none;
                        position: absolute;
                        top: 0px;
                        background: #fff;
                        z-index: 1;
                        margin-left: 100%;
                        border: 1px solid #4d95fb;
                        border-bottom: 0px;
                        span {
                            display: block;
                            padding: 2px 12px;
                            border-bottom: 1px solid #4d95fb;
                            color: #a0a0a0;
                            &:hover {
                                background-color: #f1faff;
                            }
                        }
                    }
                }
                text-align: center;
                display: inline-block;
                margin: 0px 3px;
                position: relative;
                i,
                v {
                    display: block;
                    font-style: normal;
                    padding: 0px 3px;
                    min-width: 20px;
                    min-height: 18px;
                }
                label {
                    color: #999;
                    min-width: 20px;
                    min-height: 18px;
                    display: block;
                }
            }
        }
    }
}
</style>
<style lang="scss" >
.choicepinyin {
    .middlediv {
        .el-radio {
            height: 32px;
            line-height: 32px;
        }
    }
}
</style>
